import { FC } from "react";
import { GoogleTagManager } from "@next/third-parties/google";
import { isDevelopment } from "../../../api/global";

export const GTM: FC = () => {
  if (isDevelopment) return null;
  return <GoogleTagManager gtmId="GTM-MCKNTP2" />;
};
